/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {undoDeclineShiftCover} from '../api'

export const useMutationUndoDeclineShiftCover = createReactQueryMutationHook('undoDeclineShiftCover', undoDeclineShiftCover)
